import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';
import { InProductTrialsOverlayWindowsAppGzDataProvider } from '../dataProvider/InProductTrialsOverlayWindowsAppGzDataProvider';

export class InProductTrialsOverlayWindowsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, InProductTrialsOverlayWindowsAppGzDataProvider);
  }
}
